// Format a base-unit quantity as a human breakdown using a product's units.
// e.g. base 280 with a "Box" of 50 → "5 boxes + 30 pcs". Falls back to the
// plain base count when the product has no alternate units.
//
// units: array of { name, factor_to_base, is_base } (as returned on products).
export function formatQtyInUnits(baseQty, units = []) {
  const qty = Number(baseQty) || 0;
  const alts = (units || [])
    .filter((u) => !u.is_base && (parseFloat(u.factor_to_base) || 0) > 1)
    .sort((a, b) => parseFloat(b.factor_to_base) - parseFloat(a.factor_to_base));

  if (alts.length === 0) return `${qty}`;

  // Use the largest alternate unit (e.g. Box) + remainder in base.
  const big = alts[0];
  const factor = parseFloat(big.factor_to_base) || 1;
  const whole = Math.floor(qty / factor);
  const rem = qty % factor;

  if (whole <= 0) return `${qty}`;
  const bigLabel = (big.name || "unit").toLowerCase();
  const parts = [`${whole} ${bigLabel}${whole > 1 ? "s" : ""}`];
  if (rem > 0) parts.push(`${rem} pcs`);
  return `${parts.join(" + ")} (${qty})`;
}
